module.exports = __webpack_public_path__ + "img/flags/JO.f226a55.png";